/* eslint-disable @typescript-eslint/ban-ts-comment */
import Sidebar from '../global/Sidebar'
import { Outlet } from 'react-router-dom'
import { FC, useState } from 'react'
import Topbar from '../global/Topbar'
import { Box } from '@mui/material'

type Props = object

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const HeaderSiderContentLayout: FC<Props> = (_props) => {
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleDrawerClose = () => {
    setMobileOpen(false)
  }

  return (
    <Box
      className="app"
      sx={{
        display: 'flex',
        height: '100%',
        width: '100%',
        '@media print': { height: 'auto', display: 'block' },
      }}
    >
      {/* @ts-ignore */}
      <Box sx={{ '@media print': { display: 'none' } }}>
        {/* @ts-ignore */}
        <Sidebar mobileOpen={mobileOpen} onMobileClose={handleDrawerClose} />
      </Box>

      <Box
        component="main"
        className="content"
        sx={{
          flexGrow: 1,
          width: '100%',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          '@media print': { overflow: 'visible', height: 'auto', display: 'block' },
        }}
      >
        <Box sx={{ '@media print': { display: 'none' } }}>
          <Topbar onMenuClick={handleDrawerToggle} />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            '@media print': { overflow: 'visible', height: 'auto', flexGrow: 0 },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}
